export const darkTheme = {
  colors: {
    paragraph: "#FFFFFF",
    info: "#FFFFFF",

    bg: "#0F0F0F",
    shape: "#1B1B1B",
  },
};
